<h1 mat-dialog-title>Developer options</h1>
<div mat-dialog-content class="!flex flex-col">
  <div *ngIf="!legacyUrl">
    Authority:
    <mat-radio-group [formControl]="authority" class="mb-8">
      <mat-radio-button [value]="AuthModuleConfigId.DevincoConnect">
        Devinco Connect
      </mat-radio-button>
      <mat-radio-button [value]="AuthModuleConfigId.MobileWorker">
        Mobile Worker STS
      </mat-radio-button>
      <mat-radio-button
        [value]="AuthModuleConfigId.MobileWorkerLocal"
        *ngIf="localhost"
      >
        Local
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div>
    Company selector:
    <mat-radio-group
      [formControl]="useLocalCompanySelector"
      class="mb-8"
      *ngIf="authority.value !== AuthModuleConfigId.DevincoConnect"
    >
      <mat-radio-button [value]="true">Local</mat-radio-button>
      <mat-radio-button [value]="false">STS</mat-radio-button>
    </mat-radio-group>
  </div>
  <mat-tab-group class="flex-1 overflow-hidden">
    <mat-tab label="User profile">
      <mw-data-sheet [data]="userProfile"></mw-data-sheet>
    </mat-tab>
    <mat-tab label="User claims">
      <mw-data-sheet [data]="claims"></mw-data-sheet>
    </mat-tab>
  </mat-tab-group>
</div>

<div mat-dialog-actions mat-dialog-close>
  <button mat-button>
    <span *ngIf="!requireRefresh">Close</span>
    <span *ngIf="requireRefresh">Close and refresh</span>
  </button>
</div>
